import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const formatBRL = (value) =>
  value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const InstallmentSimulator = () => {
  useDocumentMeta({
    title: 'Simulador de Compra Parcelada no Cartão | jarder.dev',
    description:
      'Veja quanto você vai pagar no total ao parcelar uma compra com ' +
      'juros. Grátis, direto no navegador.',
  })

  const [value, setValue] = useState('1000')
  const [installments, setInstallments] = useState('10')
  const [rate, setRate] = useState('3')

  const result = useMemo(() => {
    const valueNum = parseFloat(value.replace(',', '.'))
    const installmentsNum = Number.parseInt(installments, 10)
    const rateNum = parseFloat(rate.replace(',', '.'))
    if (!valueNum || !installmentsNum) return null
    const monthlyRate = rateNum / 100
    if (monthlyRate === 0) {
      const installmentValue = valueNum / installmentsNum
      return { installmentValue, total: valueNum, interest: 0 }
    }
    const installmentValue =
      (valueNum * monthlyRate * (1 + monthlyRate) ** installmentsNum) /
      ((1 + monthlyRate) ** installmentsNum - 1)
    const total = installmentValue * installmentsNum
    return { installmentValue, total, interest: total - valueNum }
  }, [value, installments, rate])

  const handleChange = () => trackEvent('tool_generate', { tool: 'installment_simulator' })

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Simulador de Compra Parcelada</h1>
      <p className="tool-disclaimer">
        Simulação com juros compostos fixos por parcela. Cartões e
        lojas podem usar métodos de cálculo diferentes.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="value">Valor da compra (R$)</label>
          <input
            id="value"
            type="text"
            inputMode="decimal"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={handleChange}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="installments">Número de parcelas</label>
          <input
            id="installments"
            type="number"
            min="1"
            value={installments}
            onChange={(e) => setInstallments(e.target.value)}
            onBlur={handleChange}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="rate">Juros ao mês (%)</label>
          <input
            id="rate"
            type="text"
            inputMode="decimal"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            onBlur={handleChange}
          />
        </div>
      </div>

      {result && (
        <div className="tool-result-card">
          <span className="tool-result-label">Valor de cada parcela</span>
          <span className="tool-result-value">{formatBRL(result.installmentValue)}</span>
          <ul className="tool-list">
            <li>
              <strong>Total pago:</strong> {formatBRL(result.total)}
            </li>
            <li>
              <strong>Total de juros:</strong> {formatBRL(result.interest)}
            </li>
          </ul>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Por que o total sobe tanto</h2>
        <p>
          Quando o cartão ou a loja cobra juros no parcelamento, cada
          parcela embute juros sobre o saldo devedor restante  quanto
          mais parcelas, mais tempo o saldo fica rendendo juros, e maior
          o total pago. Antes de parcelar com juros, vale comparar com
          pagar à vista (muitas lojas dão desconto) ou parcelar sem
          juros, quando disponível.
        </p>
      </div>
    </div>
  )
}

export default InstallmentSimulator
